import { useEffect, useState } from "react";
import { PageHeader, Spinner, Card, EmptyState } from "@/components/dash";
import api from "@/lib/api";
import { formatDate } from "@/lib/format";

export default function AdminAudit() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/audit-logs").then(({ data }) => setItems(data.logs)).catch(() => setItems([])); }, []);
  if (!items) return <Spinner />;
  return (
    <div>
      <PageHeader title="Audit Log" desc="Tüm kritik sistem işlemlerinin denetim kayıtları." />
      {items.length === 0 ? <EmptyState title="Kayıt yok" /> : (
        <Card className="overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="border-b border-border bg-muted/40"><tr className="text-left text-xs text-muted-foreground">
                {["İşlem", "Aktör", "Detay", "Tarih"].map((h) => <th key={h} className="px-4 py-3 font-medium">{h}</th>)}
              </tr></thead>
              <tbody className="divide-y divide-border" data-testid="audit-table">
                {items.map((l) => (
                  <tr key={l.id} className="hover:bg-muted/30">
                    <td className="px-4 py-3 font-mono text-xs">{l.action}</td>
                    <td className="px-4 py-3 text-muted-foreground">{l.actor}</td>
                    <td className="px-4 py-3 text-xs text-muted-foreground font-mono">{JSON.stringify(l.detail)}</td>
                    <td className="px-4 py-3 text-xs text-muted-foreground whitespace-nowrap">{formatDate(l.created_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  );
}
